import { components, GroupBase, OptionProps } from "react-select";

import { ReactComponent as CheckIcon } from "assets/images/iconsV2/check.svg";

import type { SelectOption } from "../types";

export default function SelectOptionComponent(
  props: OptionProps<SelectOption, false, GroupBase<SelectOption>>,
) {
  const { data, isSelected, children } = props;
  const hasCustomLabel = typeof children !== "string" && typeof children !== "number";

  return (
    <components.Option {...props}>
      <div className="cb-select__option-content">
        <div className="cb-select__option-label">
          {hasCustomLabel ? (
            children
          ) : (
            <>
              <span className="cb-select__option-primary">{data.label}</span>
              {data.supportingText && (
                <span className="cb-select__option-supporting-text">{data.supportingText}</span>
              )}
            </>
          )}
        </div>
        {isSelected && (
          <span className="cb-select__option-check" aria-hidden>
            <CheckIcon />
          </span>
        )}
      </div>
    </components.Option>
  );
}
